import { SecurityRuleFactory, createSimpleClaimRule } from "../auth-rules";

export type ReportsClaimType = string | string[];
export type ReportsClaimArgs = {};

export const ruleReports: SecurityRuleFactory<ReportsClaimType, ReportsClaimArgs> =
  createSimpleClaimRule<ReportsClaimType, ReportsClaimArgs>("reports");

